import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import { Button, Grid, Stack } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import { focusElemnt, isEmpty, navigation1 } from '../../../../common/helper'
import { autoReceiveDataInsertUpdate } from '../../../../../store/generalSetting/GSAction'
import { connect } from 'react-redux'
import { updateAlertError } from '../../../../../store/common/common_action'
import Alert from '../../../../common/alert'
const AutoReceiveModal = (props) => {
    const { updateModal, data, updateAlertError, autoReceiveDataInsertUpdate,
        dataValue: { editData, isEdit, mdt, headerText, branchList, userList, cityList, daysList, hoursList, minsList, setIsSuccess, setMessage, getTableData } } = props
    const { common: { loginData } } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [showAlert, setShowAlert] = useState({
        show: false,
        message: '', 
        nextId:''
      })
    const statusList = [{ id: 0, name: 'Inactive' }, { id: 1, name: 'Active' }]
    const [row, setRow] = useState(null)
    const [reset, setReset] = useState({fromBranch:false,fromUser:false})
    useEffect(() => {
        focusElemnt('revcByCity')
    }, [])
    useEffect(() => {
        if (!isEmpty(editData)) {
            setRow(editData)
        } else {
            setRow({IsActive:1})
        }
    }, [editData])
    const handleCloseAlert = (nextId) => {
        setShowAlert({ show: false, message: '', nextId: "" })
        focusElemnt(nextId)
      }
    const handleSave = () => {
        if (!row.hasOwnProperty('CityID')||row?.CityID===undefined) {
        setShowAlert({ show: true, message: "Please Select The City",nextId: 'revcByCity' }) 
        } else if (!row.hasOwnProperty('BranchID')||row?.BranchID===undefined||row?.BranchID==='') {
        setShowAlert({ show: true, message: "Please Select The Branch",nextId: 'recvByBranch' }) 
        } else if (!row.hasOwnProperty('UserID')||row?.UserID===undefined||row?.UserID==='') {
        setShowAlert({ show: true, message: "Please Select The User",nextId: 'recvByUser' }) 
        } else if (!row.hasOwnProperty('Days')||row?.Days===undefined) {
        setShowAlert({ show: true, message: "Please Select The Number Of Days",nextId: 'recvAfterDays' }) 
        } else if (!row.hasOwnProperty('Hours')||row?.Hours===undefined) {
        setShowAlert({ show: true, message: "Please Select The Number Of Hours",nextId: 'recvAfterHours' }) 
        } else if (!row.hasOwnProperty('Minutes')||row?.Minutes===undefined) {
        setShowAlert({ show: true, message: "Please Select The Number Of Minutes",nextId: 'recvAfterMins' }) 
        } else if (!row.hasOwnProperty('IsActive')||row.IsActive===undefined) {
        setShowAlert({ show: true, message: "Please Select The Number Of Status",nextId: 'recvStatus' }) 
        }else{
        let totalMins = row?.Days * 24 * 60 + +row?.Hours * 60 + +row?.Minutes
        let object = {
            BranchID: row?.BranchID,
            AutoReceiveUserID: row?.UserID,
            IsActive: row?.IsActive,
            ModifiedByUser: loginData?.intUserID,
            Minutes: totalMins
        }
        isEdit ? setMessage('Auto Receive\nUpdated Successfully!') : setMessage('New Auto Receive Config.\nSaved Successfully!')
        autoReceiveDataInsertUpdate(object)?.then((res) => {
            if (res?.status == 'Success') {
                isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoReceivePopupModal)
                setIsSuccess(true)
                getTableData()
                focusElemnt('arNewAutoRecv')
            } else {
                isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoReceivePopupModal)
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: 'arNewAutoRecv' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    }
    return (<>
        <Modal
            headTxt={headerText}
            width={'45%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <Grid container sx={{ padding: '10px 8px 10px 8px' }} >
                <Grid item md={6}>
                    <Grid container rowSpacing={1}>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='revcByCity'
                                    label={"Select Auto Receive By City"}
                                    width="100%"
                                    prevId='abtAddBtn'
                                    nextId='recvByBranch'
                                    defaultvalue={row?.CityName || ''}
                                    data={cityList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    disabled={isEdit}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, CityID: val.id, CityName: val.name, BranchID: '', BranchName: '' }))
                                        setReset((prev)=>({...prev, fromBranch:false}));
                                        setTimeout(() => {
                                            setReset((prev)=>({...prev, fromBranch:true}));
                                        }, 100);
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvByBranch'
                                    label={"Select Auto Receive By Branch"}
                                    width="100%"
                                    prevId='revcByCity'
                                    nextId='recvByUser'
                                    defaultvalue={row?.BranchName || ''}
                                    data={branchList.filter((val) => val.city === row?.CityID) || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    disabled={isEdit}
                                    onSelResetVal={true}
                                    resetFlag={reset?.fromBranch}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, BranchID: val.id, BranchName: val.name, UserID: '', UserName: '' }))
                                        setReset((prev)=>({...prev, fromUser:false}));
                                        setTimeout(() => {
                                            setReset((prev)=>({...prev, fromUser:true}));
                                        }, 100);
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvByUser'
                                    label={"Select Auto Receive By User"}
                                    width="100%"
                                    prevId='recvByBranch'
                                    nextId='recvAfterDays'
                                    defaultvalue={row?.UserName || ''}
                                    data={userList?.filter((val) => val.branch === row?.BranchID) || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    resetFlag={reset?.fromUser}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, UserID: val.id, UserName: val.name }))
                                    }}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6}>
                    <Grid container rowSpacing={1}>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvAfterDays'
                                    label={"Select Auto Receive After Days"}
                                    width="100%"
                                    prevId='recvByUser'
                                    nextId='recvAfterHours'
                                    defaultvalue={row?.Days === 1 ? `${row?.Days} Day` : row?.Days >= 0 ? `${row?.Days} Days` : '' || ''}
                                    calendarIcon={true}
                                    data={daysList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, Days: val?.id }))
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvAfterHours'
                                    label={"Select Auto Receive After Hours"}
                                    width="100%"
                                    prevId='recvAfterDays'
                                    nextId='recvAfterMins'
                                    defaultvalue={row?.Hours === 1 ? `${row?.Hours} Hour` : row?.Hours >= 0 ? `${row?.Hours} Hours` : ''}
                                    watchIcon={true}
                                    data={hoursList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, Hours: val?.id }))
                                    }}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvAfterMins'
                                    label={"Select Auto Receive After Minutes"}
                                    width="100%"
                                    prevId='recvAfterHours'
                                    nextId='recvStatus'
                                    defaultvalue={row?.Minutes === 1 ? `${row?.Minutes} Min.` : row?.Minutes >= 0 ? `${row?.Minutes} Mins.` : ''}
                                    watchIcon={true}
                                    data={minsList || []}
                                    idKey={`id`}
                                    dataKey={`name`}
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, Minutes: val?.id }))
                                    }}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container sx={{ padding: '10px 8px 10px 8px', borderTop: '1px solid #ddd' }} >
                <Grid item md={6}>
                    <Grid container rowSpacing={1}>

                        <Grid item md={12}>
                            <Item>
                                <DropDownOA
                                    id='recvStatus'
                                    label={"Status"}
                                    width="100%"
                                    prevId='recvAfterMins'
                                    nextId='abtCancelBtn'
                                    data={statusList || []}
                                    defaultvalue={isEdit? statusList[row?.IsActive]?.name : statusList[1]?.name}
                                    searchPlaceholder={`Search Status`}
                                    dataKey={`name`}
                                    idKey={`id`}
                                    isError={row?.IsActive == 0}
                                    isSuccess={row?.IsActive == 1 }
                                    onSelResetVal={true}
                                    onSelect={(val) => {
                                        setRow((prev) => ({ ...prev, IsActive: val.id }))
                                    }
                                       
                                    }
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item md={6}>
                    <Grid container rowSpacing={1}>

                        <Grid item md={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <Item>
                                <Button
                                    id="abtCancelBtn"
                                    style={{ margin: '0', height: "40px" }}
                                    className="btn cancel-btn"
                                    variant="outlined"
                                    color="error"
                                    onClick={() => {
                                        isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoReceivePopupModal)
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'abtAddBtn', 'recvStatus');
                                    }}
                                >
                                    Cancel
                                </Button></Item>
                            <Item>
                                <Button
                                    id="abtAddBtn"
                                    style={{ margin: '0', height: "40px" }}
                                    className="btn add-btn"
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                        handleSave()
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'revcByCity', 'abtCancelBtn');
                                    }}
                                >
                                    {isEdit ? 'Update' : 'Save'}
                                </Button></Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Modal>
    {showAlert.show && <Alert msg={showAlert.message} error={true} close={()=>handleCloseAlert(showAlert.nextId)} />}
</>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    autoReceiveDataInsertUpdate, updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(AutoReceiveModal)
